<div class="organization-flow-chart-element-container">
	<a class="organization-flow-chart-element-container-organization" [routerLink]="['/user/organization',organization?.id,'details']">
		<div
			class="organization-flow-chart-element-container-current"
			*ngIf="organization?.id === currentId"
		>
			<mat-icon svgIcon="md:chevron_left"></mat-icon>
		</div>
		<div class="organization-flow-chart-element-container-organization-name">
			<span class="organization-flow-chart-element-container-organization-name-link">{{organization?.name}}</span>
		</div>
	</a>
	<copo-organization-flow-chart-element *ngFor="let org of organization?.children" [organization]="org" [parent]="parent" [currentId]="currentId"
	></copo-organization-flow-chart-element>
</div>